<template>
    <v-dialog max-width="500px" v-model="dialog">
        <v-card min-width="500px">

            <v-card-actions class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <v-btn icon class="ma-2 pa-0" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>

            <v-card-actions dense class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <template v-for="(audience, index)  in getAudiences()" >
                    <v-checkbox
                            :key="audience.name"
                            color="blue"
                            :style="{'margin-left': (index != 0 ? 10 : 0) + 'px', 'margin-top':'-10px', 'margin-bottom':'10px'}"
                            v-model="selected"
                            :label="audience.name.toUpperCase()"
                            :value="audience.name"
                    ></v-checkbox>
                </template>
                <v-spacer></v-spacer>
            </v-card-actions>

            <v-card-actions dense class="ma-0 pa-0">
                <v-spacer></v-spacer>
                <template v-for="(audience, index)  in getCustomAudiences()" >
                    <v-checkbox
                            :key="audience.name"
                            color="red"
                            :style="{'margin-left': (index != 0 ? 10 : 0) + 'px', 'margin-top':'-10px', 'margin-bottom':'20px'}"
                            v-model="selected"
                            :label="audience.name.toUpperCase()"
                            :value="audience.name"
                    ></v-checkbox>
                </template>
                <v-spacer></v-spacer>
            </v-card-actions>

            <v-card-actions style="margin-top: -25px">
                <v-spacer></v-spacer>
                <v-btn
                        :loading="buttonLoading"
                        elevation="0"
                        :disabled="uid == null"
                        class="ma-2 white--text"
                        color="blue"
                        @click="onPressDeploy">DEPLOY
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

import {UsersBackendUtils} from "@/modules/mprofiles/database/UsersBackendUtils";
import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";

export default {
    name: "p-f-u-edit-audience-popup",
    props: {},
    data: () => ({
        dialog: false,
        uid: null,
        buttonLoading: false,
        selected:[],
    }),
    computed: {

    },
    methods: {
        getAudiences(){
            return AudienceTestStoreUtils.getAudiences()
        },
        getCustomAudiences(){
            return AudienceTestStoreUtils.getCustomAudiences()
        },
        show(uid) {
            this.uid = uid
            this.dialog = true
            this.selected = ''
        },
        onClose() {
            this.dialog = false
            this.buttonLoading = false
        },
        onPressDeploy() {
            this.buttonLoading = true
            UsersBackendUtils.setAudience(this.uid, this.selected)
            .then(() => {
            this.buttonLoading = false
            this.dialog = false
            this.$notify({title: 'Audience successfully updated!', text: "", type: "succes"});
            })
            .catch((error) => {
                this.buttonLoading = false
                this.dialog = false
                this.$notify({title: 'Audience updated failed!', text: error, type: "error"});
            })

        }
    }
}
</script>

<style scoped>
</style>